module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTPro-BdIt.c1878bf.woff2";